"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
var Title;
(function (Title) {
    Title["HEER"] = "heer";
    Title["MEVROUW"] = "mevrouw";
    Title["BEDRIJF"] = "bedrijf";
    Title["BOTH"] = "heer / mevrouw";
    Title["NABESTAANDE"] = "nabestaande van";
})(Title = exports.Title || (exports.Title = {}));
exports.default = Title;
